import { render } from "./EditMyInfo.vue?vue&type=template&id=dca92b94"
import script from "./EditMyInfo.vue?vue&type=script&lang=js"
export * from "./EditMyInfo.vue?vue&type=script&lang=js"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__